// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2e0Hr","messages":"Chat_messages__Z9xrN","dateDivider":"Chat_dateDivider__leEY_"};